/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import { typeof as _typeof, slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';

var getQueryParams = (function (queryParams, encode) {
  if (!queryParams) return '';
  if (typeof queryParams === 'string') {
    // For strings, make sure the query string starts with '?'
    return queryParams.charAt(0) === '?' ? queryParams : "?".concat(queryParams);
  }
  if (_typeof(queryParams) === 'object') {
    // For objects, generate a query string that only includes values that are defined
    var cleanedQueryParams = [];
    Object.entries(queryParams).forEach(function (entry) {
      var _entry = _slicedToArray(entry, 2),
        key = _entry[0],
        value = _entry[1];
      if (value !== null && value !== undefined && value !== '') {
        var encodedValue = encode ? encodeURIComponent(value) : value;
        cleanedQueryParams.push("".concat(key, "=").concat(encodedValue));
      }
    });
    return "?".concat(cleanedQueryParams.join('&'));
  }
  return '';
});

export { getQueryParams as default };
